import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
import { Ge as b, bo as e, hi as v, M as n } from "./abstract-base-8edf0a84-e11d45a3.js";
import { c as g } from "./table-cell-7d34e150-56a6eaa3.js";
import { e as h } from "./state-b4c9cc73-ee633f6c.js";
import { u as f } from "./class-map-ad981c82-cb73357b.js";
import { A as u } from "./query-assigned-ba663908-228b08f4.js";
var l = /* @__PURE__ */function (o) {
  return o.TEXT = "text", o.NUMERAL = "numeral", o.DATE = "date", o.ICONS = "icons", o;
}(l || {});
var y = b(_templateObject || (_templateObject = _taggedTemplateLiteral(["[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-unit-base))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-unit-atomic)}.beacon-table-record__footnote{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default))}\n"]))),
  w = b(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{color:var(--beacon-color-text-default-on-light);inline-size:inherit;word-break:initial}.record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-default);--margin-start: var(--beacon-table-record-space-margin-inline-start-default);display:flex;margin-inline-end:var(--margin-end);margin-inline-start:var(--margin-start)}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-secondary);--margin-start: var(--beacon-table-record-space-margin-inline-start-secondary)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-table-record-space-margin-inline-end-sorting)}.record-numeral{align-items:center;display:flex;flex-wrap:wrap;gap:calc(.125 * var(--beacon-unit-base)) calc(.75 * var(--beacon-unit-base));justify-content:end;margin-block-end:calc(.125 * var(--beacon-unit-base))}.record-na{color:var(--beacon-colors-light-grey-1)}.record-cell{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));flex-grow:1;margin-block-start:var(--beacon-unit-subatomic)}.record-cell:is(.numeral,.date){text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold>:is(.record-numeral,.record-na),.record-cell.sorted>:is(.record-numeral,.record-na){font-weight:var(--beacon-font-weight-bold)}.record-delta{align-items:center;display:flex}.record-delta-value{color:var(--beacon-colors-medium-grey-1)}.record-delta-icon{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewbox='0 0 16 16' style='fill: %23248647; transform: rotate(180deg);'%3E%3Cpolygon points='4,5 8,11 12,5'/%3E%3C/svg%3E\");block-size:var(--beacon-unit-base);display:inline-block;inline-size:var(--beacon-unit-base)}.record-delta-icon.negative{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16px' width='16px' viewbox='0 0 16 16' style='fill: %23DD3636;'%3E%3Cpolygon points='4,5 8,11 12,5'/%3E%3C/svg%3E\")}.record-footnote{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default));color:var(--beacon-colors-medium-grey-1);margin:0}::slotted(p){margin:0}.empty{display:none}.action-zone:not(.empty){display:grid;grid-template-rows:1fr 1fr;inline-size:calc(2.5 * var(--beacon-unit-base));margin-block-start:calc(var(--beacon-unit-subatomic) + var(--beacon-cell-space-padding));place-items:center}::slotted(svg){block-size:var(--beacon-table-record-icon-size);inline-size:var(--beacon-table-record-icon-size)}\n"])));
var x = Object.defineProperty,
  z = Object.getOwnPropertyDescriptor,
  r = function r(o, a, s, c) {
    for (var i = c > 1 ? void 0 : c ? z(a, s) : a, d = o.length - 1, p; d >= 0; d--) (p = o[d]) && (i = (c ? p(a, s, i) : p(i)) || i);
    return c && i && x(a, s, i), i;
  };
var m = "beacon-table-record",
  $ = e(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["&#8212"])));
var t = /*#__PURE__*/function (_v) {
  _inherits(t, _v);
  function t() {
    var _this;
    _classCallCheck(this, t);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments)), _this.beaconTagName = m, _this.variant = l.TEXT, _this.sorted = !1, _this.hasActionZoneContent = !1;
    return _this;
  }
  _createClass(t, [{
    key: "setActionZoneStatus",
    value: function setActionZoneStatus() {
      this.hasActionZoneContent = this.actionZone.length > 0;
    }
    /**
     * Sets styles based on slot values
     */
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.setActionZoneStatus();
    }
    /**
     * Renders slot element with default styles
     * @returns default empty slot styles
     */
  }, {
    key: "renderSlot",
    value: function renderSlot() {
      return e(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<slot><span class=\"record-na\">", "</span></slot>"])), $);
    }
    /**
     * Renders numeral and delta with proper spacing
     * @returns HTML template for numeral element in numeral record
     */
  }, {
    key: "renderNumeral",
    value: function renderNumeral() {
      var a = this.delta && !this.hideDeltaIcon ? e(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<span class=\"record-delta-icon ", "\"></span>"])), this.deltaPositive ? "" : "negative") : e(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
      return !this.hideDeltaValue && this.delta ? e(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<span class=\"record-delta\"> ", "<span class=\"record-delta-value\">", "</span> </span\n        >", ""])), a, this.delta, this.renderSlot()) : e(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), this.delta ? e(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["<span class=\"record-delta\">", "", "<span></span></span>"])), a, this.renderSlot()) : e(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ""])), this.renderSlot()));
    }
    /**
     * Conditionally renders cell contents
     * @returns HTML template according to variant type
     */
  }, {
    key: "renderCell",
    value: function renderCell() {
      switch (this.variant) {
        case l.NUMERAL:
          return e(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["<div class=\"record-numeral\">", "</div>\n          <p class=\"record-footnote\">", "</p>"])), this.renderNumeral(), this.footnote);
        case l.DATE:
        case l.TEXT:
        case l.ICONS:
        default:
          return e(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["", ""])), this.renderSlot());
      }
    }
    /**
     * Default render function
     * @returns HTML template for table record component
     */
  }, {
    key: "render",
    value: function render() {
      return e(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["<div class=\"record-cell-wrapper\" part=\"cell-wrapper\">\n      <div class=\"has-cell-padding record-cell ", " ", " ", "\" part=\"cell\">\n        ", "\n      </div>\n      ", "\n    </div>"])), this.bold ? "bold" : "", this.sorted ? "sorted" : "", this.variant, this.renderCell(), this.variant === l.NUMERAL ? e(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["<div class=\"action-zone ", "\" part=\"action-zone\">\n            <slot name=\"action-zone\"></slot>\n          </div>"])), f({
        empty: !this.hasActionZoneContent
      })) : e(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([""]))));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var a;
      (a = this.handleDefer()) == null || a.then(function () {
        _get(_getPrototypeOf(t.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }, {
    key: "deltaValue",
    /**
     * Getter for deltaValue
     *
     * @returns parsed delta string value
     */
    get: function get() {
      return parseFloat(this.delta);
    }
    /**
     * Returns sign of delta to determine delta icon styles
     *
     * @returns true/false for positive/negative respectively
     */
  }, {
    key: "deltaPositive",
    get: function get() {
      return this.deltaValue > 0;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(t), "styles", this), w];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(t), "lightDOMStyles", this)), [y]);
    }
  }]);
  return t;
}(v(g));
t.tagName = m;
r([n({
  reflect: !0
})], t.prototype, "footnote", 2);
r([n({
  reflect: !0
})], t.prototype, "variant", 2);
r([n({
  reflect: !0
})], t.prototype, "delta", 2);
r([n({
  attribute: "sort-value",
  reflect: !0
})], t.prototype, "sortValue", 2);
r([n({
  type: Boolean,
  reflect: !0
})], t.prototype, "bold", 2);
r([n({
  type: Boolean,
  reflect: !0
})], t.prototype, "sorted", 2);
r([n({
  type: Boolean,
  reflect: !0,
  attribute: "hide-delta-icon"
})], t.prototype, "hideDeltaIcon", 2);
r([n({
  type: Boolean,
  reflect: !0,
  attribute: "hide-delta-value"
})], t.prototype, "hideDeltaValue", 2);
r([h()], t.prototype, "hasActionZoneContent", 2);
r([u({
  slot: "action-zone"
})], t.prototype, "actionZone", 2);
var D = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  BeaconTableRecord: t
}, Symbol.toStringTag, {
  value: "Module"
}));
export { D as index, l, t };